import { Show } from "shared/components";

// Tooltip on the disabled Chat tab. Two distinct flows (QA, CRM-1133):
//  - the contact was never invited (no application at all, or only canceled /
//    merged ones): explain, and offer Invite to apply;
//  - the contact is already invited but has not started the application
//    (application status `pending`): explain, no Invite button — re-inviting
//    someone who is already invited only confuses.
export const ChatDisabledTooltip = ({
  invitedNotStarted,
  onInvite
}: {
  invitedNotStarted: boolean;
  onInvite: () => void;
}) => (
  <div className="flex flex-col gap-2.5">
    <span className="block max-w-[288px] font-medium leading-5">
      {invitedNotStarted
        ? "To use chat, the applicant must start the application."
        : "To use chat, the contact must have at least one application."}
    </span>
    <Show if={!invitedNotStarted}>
      <button
        type="button"
        onClick={onInvite}
        className="flex h-[34px] items-center justify-center self-start rounded-lg bg-primary-500 px-3.5 text-[13px] font-bold leading-4 text-content-1000-inverted shadow-xs"
      >
        Invite to apply
      </button>
    </Show>
  </div>
);
